import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { HardHatIcon, XIcon } from 'lucide-react';
import { PRODUCT_NAME, PURCHASE_ANCHOR, popupSales } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = (i: number) => {
      timeout = setTimeout(() => {
        setIndex(i % popupSales.length);
        setVisible(true);
        timeout = setTimeout(() => {
          setVisible(false);
          cycle(i + 1);
        }, 5200);
      }, 3200);
    };
    cycle(0);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const sale = popupSales[index];
  const y = reduceMotion ? 0 : 14;
  return <AnimatePresence data-id="element-158" data-mp="18rncdvu0cv8j">
      {visible && !dismissed ? <motion.aside initial={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2 left-2 z-50 w-[14.5rem] overflow-hidden rounded-lg border-2 border-hazard bg-ink shadow-xl shadow-hazard/30 ring-2 ring-hazard/40 sm:w-[17rem]" aria-live="polite" data-id="element-159" data-mp="1zse42bllhamu">
          <div className="flex items-center gap-1.5 bg-hazard px-2 py-1" data-id="element-160" data-mp="2nge647ocwngq">
            <HardHatIcon className="h-3.5 w-3.5 text-ink" strokeWidth={2.5} aria-hidden="true" data-id="element-161" data-mp="2sga6zy1rbys2" />
            <p className="font-display text-[0.56rem] font-extrabold uppercase tracking-[0.14em] text-ink" data-id="element-162" data-mp="2xfd1wpo0womb">
              New purchase verified
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="ml-auto text-ink/70 transition-colors duration-150 ease-out hover:text-ink" data-id="element-163" data-mp="y3tw2jy0nwgv">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-164" data-mp="q233yerzay7h" />
            </button>
          </div>
          <div className="hazard-stripes h-1" aria-hidden="true" data-id="element-165" data-mp="14zdb5bxl9hxe" />
          <a href={PURCHASE_ANCHOR} className="block px-2 py-1.5" data-id="element-166" data-mp="14whctmhtwr8f">
            <p className="text-[0.72rem] font-bold leading-tight text-white" data-id="element-167" data-mp="zy62lanmgepo">
              {sale.name} just bought <span className="text-hazard" data-id="element-168" data-mp="1dxxjbj5iw97d">{PRODUCT_NAME}</span>
            </p>
            <p className="mt-0.5 text-[0.62rem] font-semibold text-steel" data-id="element-169" data-mp="18zdw7ff70rdf">
              {sale.city}, {sale.country} • a few minutes ago
            </p>
          </a>
        </motion.aside> : null}
    </AnimatePresence>;
}